import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

const Button = styled.div`
    border-radius: 15px;
    border: 1px solid #f8cd23;
    background: #163c65;
    color: #f8cd23;
    padding: 40px 20px;
    min-width: 200px;
    text-align: center;
    cursor: pointer;
    font-weight: bold;
    font-size: 18px;
    &:hover {
        border: 1px solid #163c65;
        background: #f8cd23;
        color: #163c65;
    }
`;

const JSROverlay = ({ handleClose, history }) => {
    const navigateTo = (url) => {
        history.push(url);
        handleClose();
    };

    return (
        <Grid
            spacing={1}
            container
            direction={'row'}
            alignItems={'center'}
            justifyContent={'center'}
        >
            <Grid item>
                <Button onClick={() => navigateTo('/facilities/file-upload')}>
                    File Upload
                </Button>
            </Grid>
            <Grid item>
                <Button
                    onClick={() =>
                        navigateTo('/pages/61447b6583c3040d7c1d9a46')
                    }
                >
                    Sales Activity
                </Button>
            </Grid>
        </Grid>
    );
};

export default JSROverlay;

JSROverlay.propTypes = {
    handleClose: PropTypes.func.isRequired,
};
